var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-part'),_c('div',{staticClass:"my-content"},[_c('home-grid',{attrs:{"menuList":_vm.getAllMenuAPPattr}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }